import { render, staticRenderFns } from "./Topmenu.vue?vue&type=template&id=572fa1da&scoped=true&"
import script from "./Topmenu.vue?vue&type=script&lang=js&"
export * from "./Topmenu.vue?vue&type=script&lang=js&"
import style0 from "./Topmenu.vue?vue&type=style&index=0&id=572fa1da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572fa1da",
  null
  
)

export default component.exports